export default class SceneUIStats {
  public static count: number = 0;
  public static visibleCount: number = 0;
}